"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORIFLAME_LOGO_ROOT = void 0;
const ORIFLAME_LOGO_ROOT = exports.ORIFLAME_LOGO_ROOT = 'oriflame-logo';
